import * as React from "react"
import { cva } from "class-variance-authority"
import { cn } from "@/lib/utils"

/**
 * Separator component for visual dividers
 */
const separatorVariants = cva(
    "shrink-0 bg-border",
    {
        variants: {
            orientation: {
                horizontal: "h-[1px] w-full",
                vertical: "h-full w-[1px]",
            },
            spacing: {
                none: "",
                sm: "",
                md: "",
                lg: "",
            },
        },
        compoundVariants: [
            {
                orientation: "horizontal",
                spacing: "sm",
                className: "my-2",
            },
            {
                orientation: "horizontal",
                spacing: "md",
                className: "my-4",
            },
            {
                orientation: "horizontal",
                spacing: "lg",
                className: "my-6",
            },
            {
                orientation: "vertical",
                spacing: "sm",
                className: "mx-2",
            },
            {
                orientation: "vertical",
                spacing: "md",
                className: "mx-4",
            },
            {
                orientation: "vertical",
                spacing: "lg",
                className: "mx-6",
            },
        ],
        defaultVariants: {
            orientation: "horizontal",
            spacing: "md",
        },
    }
)

const Separator = React.forwardRef(
    ({ className, orientation, spacing, decorative = true, ...props }, ref) => (
        <div
            ref={ref}
            role={decorative ? "none" : "separator"}
            aria-orientation={orientation}
            className={cn(separatorVariants({ orientation, spacing }), className)}
            {...props}
        />
    )
)
Separator.displayName = "Separator"

export { Separator }
